import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { getErrorPath } from '../Notes.helpers';
import SectionBase from './sectionBase/SectionBase';
import SectionEncounter from './sectionEncounter/SectionEncounter';
const Section = ({ $section }) => {
    const isInvalid = Object.values($section.errors).some((x) => {
        return x.has(getErrorPath($section.id));
    });
    if ($section.id === 'encounter') {
        return _jsx(SectionEncounter, { "$section": $section, hasError: isInvalid });
    }
    return _jsx(SectionBase, { "$section": $section, hasError: isInvalid }); //
};
export default observer(Section);
